import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface BusinessSummaryData {
  id: string;
  title: string;
  welcome_message: string;
  story: string;
  mission: string;
  vision: string;
  created_at: string;
  updated_at: string;
}

export const useBusinessSummary = () => {
  return useQuery({
    queryKey: ['businessSummary'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('business_summary')
        .select('*')
        .single();
      
      if (error) throw error;
      return data as BusinessSummaryData;
    },
  });
};